const APP_PRODUCT = {
  NAME: 'NVZN3D',
  HEADLINE: 'AR previews powered by Nvzn',
  CTA: 'Discover more at',
  LINK: 'https://nvzn.net',
  COLOR1: '#696AAB',
  COLOR2: '#9798CA',
};

function openNvzn3DPreview({
  nvznID, // required
  variantID,
  language,
} = {}) {
  // validation
  if (!nvznID) throw new Error('Nvzn3D: nvznID is required');
  // get nvzn url
  const url = getNvzn3DPreviewUrl({
    nvznID,
    variantID,
    language,
  });
  // find top z-index for modal overlay
  let maxZIndex = 0;
  document.querySelectorAll('*').forEach((element) => {
    const zIndex = parseInt(window.getComputedStyle(element).zIndex, 10);
    if (!isNaN(zIndex) && zIndex > maxZIndex) {
      maxZIndex = zIndex;
    }
  });
  // create nvzn modal
  const modal = document.createElement('div');
  modal.id = 'nvzn3d-modal';
  modal.classList.add('nvzn3d-modal', 'nvzn3d-showable');
  modal.style.zIndex = maxZIndex + 1;
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Augmented Reality Viewer');
  modal.setAttribute(
    'aria-description',
    'Interactive viewer that lets you see this product in your space using your device camera. Press escape to close.'
  );
  // create modal content
  modal.innerHTML = `
    <div class="nvzn3d-modal-content">
      <div id="nvzn3d-loading-spinner" class="nvzn3d-loading-spinner"> </div>
      <button 
        id="nvzn3d-modal-close" 
        class="nvzn3d-modal-close"
        aria-label="Close Augmented Reality viewer"
      >
        <svg 
          class="nvzn3d-modal-close" 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 30 30"
          aria-hidden="true"
        >
          <circle cx="15" cy="15" r="14" />
          <path d="M10 10L20 20M20 10L10 20" />
        </svg>
      </button>
      <iframe
        id="nvzn3d-iframe"
        class="nvzn3d-iframe"
        src=""
        allow="xr-spatial-tracking *; clipboard-write *; fullscreen *; web-share;"
        allowfullscreen
        mozallowfullscreen
        webkitallowfullscreen
      ></iframe>
    </div>
  `;
  // prevent parent page from scrolling while displaying modal
  document.body.style.overflow = 'hidden';
  // handle background click to close modal
  modal.addEventListener('click', closeNvzn3DPreview, { once: true });
  // handle modal close button
  modal
    .querySelector('#nvzn3d-modal-close')
    .addEventListener('click', closeNvzn3DPreview, { once: true });
  // handle escape key to close modal
  window.addEventListener('keydown', nvzn3DHandleEscape, { once: true });
  // add modal
  document.body.appendChild(modal);
  // transition in modal
  requestAnimationFrame(() => {
    modal.classList.add('nvzn3d-show');
  });
  // once transition complete, load iframe src
  modal.addEventListener(
    'transitionend',
    function () {
      if (!modal.classList.contains('nvzn3d-show')) return;
      modal.querySelector('#nvzn3d-iframe').src = url;
      // on iframe load, remove loading spinner
      modal.querySelector('#nvzn3d-iframe').addEventListener('load', () => {
        document.querySelector('#nvzn3d-loading-spinner').remove();
      });
    },
    { once: true }
  );
}
// escape button closes modal
function nvzn3DHandleEscape(event) {
  if (event.key === 'Escape') {
    closeNvzn3DPreview();
  }
}
// close and remove modal
function closeNvzn3DPreview() {
  const modal = document.querySelector('#nvzn3d-modal');
  if (modal && modal.classList.contains('nvzn3d-show')) {
    window.removeEventListener('keydown', nvzn3DHandleEscape);
    document.body.style.overflow = '';
    modal.classList.remove('nvzn3d-show');
    // once transition complete, remove modal from DOM
    modal.addEventListener(
      'transitionend',
      function () {
        if (modal.classList.contains('nvzn3d-show')) return;
        modal.querySelector('#nvzn3d-iframe').src = 'about:blank';
        modal.style.display = 'none';
        modal.remove();
      },
      { once: true }
    );
  }
}

// generate nvzn 3d preview url
function getNvzn3DPreviewUrl({
  nvznID, // required
  variantID,
  language,
} = {}) {
  if (!nvznID) throw new Error('Nvzn3D: nvznID is required');
  const baseUrl = `https://nvzn.io/player/${nvznID}`;

  const hashParams = new URLSearchParams();
  if (variantID !== undefined && variantID !== null && variantID !== '') {
    hashParams.set('variant', String(variantID));
  }
  if (language !== undefined && language !== null && language !== '') {
    hashParams.set('lang', String(language));
  }
  const hash = hashParams.toString();

  return hash ? `${baseUrl}#${hash}` : baseUrl;
}

function logProductSignature() {
  console.log(
    `%c ${APP_PRODUCT.NAME} %c ${APP_PRODUCT.HEADLINE} %c ${APP_PRODUCT.CTA} ${APP_PRODUCT.LINK}`,
    `background: ${APP_PRODUCT.COLOR1}; color: white; font-family: Tahoma, sans-serif; font-weight: bold; padding: 4px 6px 4px 10px; border-radius: 20px 0 0 20px; white-space: nowrap;`,
    `background: ${APP_PRODUCT.COLOR2}; color: white; font-family: Tahoma, sans-serif; font-weight: normal; padding: 4px 10px 4px 6px; border-radius: 0 20px 20px 0; margin-right: 12px; white-space: nowrap;`,
    `color: #525252; font-family: Tahoma, sans-serif; font-weight: normal; font-size: 0.8em; white-space: nowrap;`
  );
}
logProductSignature();